import(/* webpackMode: "eager" */ "/home/ubuntu/app/hellojob-pro/src/app/gop-y/page.tsx");
